import React from 'react';
import MyFavourite from '../../favourite/components/favourite4Theme.js';

class WeaFavourite extends React.Component {
  render() {
    return <MyFavourite>{this.props.children}</MyFavourite>;
  }
}

export default WeaFavourite;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-favourite/index.js